// extracted by mini-css-extract-plugin
export default {"root":"ajjRI0Tt3HnPXhgdPCxq","wrap":"nXwiJ3mMTYD5pCvXULAs","left":"Bt_HyrmjuyyVOCpcFKXQ","x":"Qb0fD5_81NmlYWVB1p_a","icon":"zbaaZyOr8ZyLCYQFxqno","input":"csnRmUC16tPKRIhM7mWn"};